import type { PageMetaKey } from '../config/pageMeta';

export type SiteRouteDef = {
  pageKey: PageMetaKey;
  /** Dil öneksiz kanonik yol */
  path: string;
  /** Sitemap ve hreflang'e dahil et */
  indexable: boolean;
};

/**
 * SEO ve sitemap için tek kaynak — yollar dil öneksiz tutulur.
 * Router child path'leri bu kayıttan türetilir.
 */
export const SITE_ROUTES: SiteRouteDef[] = [
  { pageKey: 'home', path: '/', indexable: true },
  { pageKey: 'cozumler', path: '/cozumler', indexable: true },
  { pageKey: 'cozumlerSap', path: '/cozumler/sap-business-one', indexable: true },
  { pageKey: 'cozumlerLogo', path: '/cozumler/logo', indexable: true },
  { pageKey: 'cozumlerDnasoft', path: '/cozumler/dnasoft', indexable: true },
  { pageKey: 'cozumlerDnasoftCaf', path: '/cozumler/dnasoft/caf', indexable: true },
  { pageKey: 'cozumlerDnasoftKaf', path: '/cozumler/dnasoft/kaf', indexable: true },
  { pageKey: 'cozumlerBoyum', path: '/cozumler/boyum-it', indexable: true },
  { pageKey: 'cozumlerComputec', path: '/cozumler/computec', indexable: true },
  { pageKey: 'cozumlerCoresystems', path: '/cozumler/coresystems', indexable: true },
  { pageKey: 'cozumlerLogosoft', path: '/cozumler/logosoft', indexable: true },
  { pageKey: 'cozumlerYapayZeka', path: '/cozumler/yapay-zeka', indexable: true },
  { pageKey: 'hizmetler', path: '/hizmetler', indexable: true },
  { pageKey: 'urunler', path: '/urunler', indexable: true },
  { pageKey: 'urunlerProintercompany', path: '/urunler/prointercompany', indexable: true },
  { pageKey: 'urunlerProbi', path: '/urunler/probi', indexable: true },
  { pageKey: 'urunlerProbank', path: '/urunler/probank', indexable: true },
  { pageKey: 'urunlerProhr', path: '/urunler/prohr', indexable: true },
  { pageKey: 'urunlerPromes', path: '/urunler/promes', indexable: true },
  { pageKey: 'urunlerPromobile', path: '/urunler/promobile', indexable: true },
  { pageKey: 'iletisim', path: '/iletisim', indexable: true },
  { pageKey: 'destekIndir', path: '/destek/indir', indexable: true },
  { pageKey: 'hakkimizda', path: '/hakkimizda', indexable: true },
  { pageKey: 'gizlilik', path: '/yasal/gizlilik', indexable: true },
  { pageKey: 'cerezler', path: '/yasal/cerezler', indexable: true },
  { pageKey: 'notFound', path: '/404', indexable: false },
];

const byPageKey = new Map(SITE_ROUTES.map((r) => [r.pageKey, r]));
const byPath = new Map(SITE_ROUTES.map((r) => [r.path, r]));

export function getSiteRouteByPageKey(pageKey: PageMetaKey): SiteRouteDef | undefined {
  return byPageKey.get(pageKey);
}

export function getSiteRouteByPath(canonicalPath: string): SiteRouteDef | undefined {
  const normalized = canonicalPath.split(/(?=[?#])/)[0].replace(/\/+$/, '') || '/';
  return byPath.get(normalized);
}

export function resolvePageKeyFromPath(canonicalPath: string): PageMetaKey | undefined {
  return getSiteRouteByPath(canonicalPath)?.pageKey;
}

/** Sitemap için yalnızca indexlenebilir yollar */
export function getIndexableCanonicalPaths(): string[] {
  return SITE_ROUTES.filter((r) => r.indexable).map((r) => r.path);
}
